import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/welp/Nav";
import PageBg, { POSTER_P4_ZODIAC } from "@/components/welp/PageBg";
import { SynastryResultCards } from "@/pages/ZodiacPage";
import { Heart } from "lucide-react";

export default function SharedSynastryPage() {
  const { sid } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.sharedSynastry(sid)
      .then(setData)
      .catch(e => setErr(e?.response?.data?.detail || "This shared reading doesn't exist or was removed."));
  }, [sid]);

  return (
    <PageBg poster={POSTER_P4_ZODIAC}>
      <Nav />
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-14 md:py-20" data-testid="shared-synastry-page">
        <div className="text-veil">
          <div className="text-xs uppercase tracking-[0.32em] mb-3">
            <span className="text-[#10B981]">Welp</span> <span className="text-[#5A5A5A]">·</span> <span className="text-[#FF1A82]">Dating With Integrity</span> <span className="text-[#5A5A5A]">·</span> Shared Synastry
          </div>
          {data && (
            <h1 className="font-heading text-4xl sm:text-5xl text-[#1A1A1A]">
              <span className="italic text-[#10B981]">{data.a_label}</span> <Heart className="inline w-8 h-8 text-[#10B981] -mt-2" /> <span className="italic text-[#FF1A82]">{data.b_label}</span>
            </h1>
          )}
        </div>

        {err && (
          <div className="mt-10 rounded-3xl bg-white/70 backdrop-blur-lg shadow-lg border border-black/10 p-8" data-testid="shared-synastry-error">
            <p className="text-lg text-[#1A1A1A] font-semibold">{err}</p>
            <Link to="/" className="mt-4 inline-block text-lg text-[#10B981] font-bold hover:underline">Go to Welp →</Link>
          </div>
        )}
        {!data && !err && <p className="mt-10 text-lg text-[#3A3A3A] font-semibold">Loading the reading…</p>}

        {data && (
          <div className="mt-10 space-y-6" data-testid="shared-synastry-result">
            <SynastryResultCards data={data} />
            <div className="rounded-3xl border-2 border-[#10B981] bg-white/70 backdrop-blur-lg p-8 text-center shadow-lg" data-testid="shared-synastry-cta">
              <p className="font-heading text-2xl font-bold text-[#1A1A1A]">Someone shared this reading with you.</p>
              <p className="mt-2 text-lg text-[#3A3A3A] font-semibold">This synastry was computed from two real birth charts using exact planetary positions — raw honesty included. Want yours?</p>
              <Link to="/register" data-testid="shared-synastry-join-btn"
                className="mt-5 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#10B981] text-white text-lg font-bold hover:brightness-110 transition">
                <Heart className="w-5 h-5" /> Get my own reading — join Welp
              </Link>
            </div>
          </div>
        )}
      </section>
    </PageBg>
  );
}
